module.exports = __webpack_public_path__ + "img/school_tysyz1.baab01f0.png";